module.exports = __webpack_public_path__ + "static/logo-4f53dce5911a846e4938f4911ea46296.png";